import React from 'react';
import { useSelector } from 'react-redux';
import { designSystem } from '@yola/ws-ui';
import getErrorMessage from '../selectors/error-message';

const { NotificationMessage, Paragraph } = designSystem;

const ErrorMessageContainer = () => {
  const errorMessage = useSelector(getErrorMessage);

  if (!errorMessage) {
    return null;
  }

  return (
    <NotificationMessage
      align="center"
      appearance="danger"
      title={
        <Paragraph appearance="danger">
          <span
            // eslint-disable-next-line yola/react/no-danger
            dangerouslySetInnerHTML={{ __html: errorMessage }}
          />
        </Paragraph>
      }
    />
  );
};

export default ErrorMessageContainer;
